import { useMutation } from '@apollo/client';
import { useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { GQL_CREATE_CONNECTION } from '~/gql/connection/connection';
import useConnectionStore from '~/helpers/store/connection/connection';

export function useConnection() {
  const { setSession, setConnectionId, setCurrentTrackings, currentTrackings } =
    useConnectionStore();
  const sessionUuid = useConnectionStore((state) => state.sessionUuid);

  const [createConnection] = useMutation(GQL_CREATE_CONNECTION, {
    onCompleted: (data) => {
      setSession(data.createConnection.sessionUuid);
      setConnectionId(data.createConnection.id);

      // check si dans currentTracking in store il y a des tracking avec d'autres sessionUuid => les supprimer
      const _newTrackings = currentTrackings.filter(
        (el) => el.sessionUuid === sessionUuid
      );
      setCurrentTrackings(_newTrackings);
    },
  });

  const createNewConnection = async (_uuid: string) => {
    await createConnection({
      variables: { sessionUuid: _uuid },
    });
  };

  useEffect(() => {
    void createNewConnection(sessionUuid ? sessionUuid : uuidv4());
  }, []);

  return sessionUuid;
}
